import React, { useState, useEffect } from "react";
import { Button, Col, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import { useGetGeneralsQuery } from "../../store/api";
import { useGeneralSheetHook } from "../../hooks/sheet.hook";
import { COUNTRIES, removeSpaces } from "../../common/data";
import Copyable from "../../common/copy/Copyable";
import { toast } from "react-toastify";

const FORM_DEFAULT = {
  donationAmount: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  address: "",
  country: "",
  message: "",
  paymentCountry: "",
  paymentMethod: "",
  currency:"NGN"
};
const DonateComponent = () => {
  const sheet_data = useGeneralSheetHook();

  const [formData, setFormData] = useState({
    donationAmount: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    country: "Nigeria",
    message: "",
    paymentCountry: "",
    paymentMethod: "",
    currency:"NGN"
  });

  const isActive = (method) => formData.paymentMethod === method;

  const [isLoading, setIsLoading] = useState(false);

  let publicUrl = process.env.PUBLIC_URL + "/";


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.value,
    }));
  };

  const handleAmountClick = (amount) => {
    setFormData((prevData) => ({
      ...prevData,
      donationAmount: amount,
    }));
  };

  const handlePaymentMethodClick = (method) => {
    setFormData((prevData) => ({
      ...prevData,
      paymentMethod: method,
    }));
  };

  useEffect(() => {
    const $ = window.$;

    if ($("#donate-amount__predefined").length) {
      let donateInput = $("#donate-amount");
      $("#donate-amount__predefined")
        .find("li")
        .on("click", function (e) {
          e.preventDefault();
          let amount = $(this).find("a").text();
          donateInput.val(amount);
          $("#donate-amount__predefined").find("li").removeClass("active");
          $(this).addClass("active");
          handleAmountClick(amount);
        });
    }

    if ($(".progress-levels .progress-box .bar-fill").length) {
      $(".progress-box .bar-fill").each(function () {
        $(".progress-box .bar-fill").appear(function () {
          var progressWidth = $(this).attr("data-percent");
          $(this).css("width", progressWidth + "%");
        });
      });
    }

    if ($(".count-bar").length) {
      $(".count-bar").appear(function () {
        var el = $(this);
        var percent = el.data("percent");
        $(el).css("width", percent).addClass("counted");
      });
    }

    if ($(".count-box").length) {
      $(".count-box").appear(function () {
        var $t = $(this),
          n = $t.find(".count-text").attr("data-stop"),
          r = parseInt($t.find(".count-text").attr("data-speed"), 10);

        if (!$t.hasClass("counted")) {
          $t.addClass("counted");
          $({ countNum: $t.find(".count-text").text() }).animate(
            {
              countNum: n,
            },
            {
              duration: r,
              easing: "linear",
              step: function () {
                $t.find(".count-text").text(Math.floor(this.countNum));
              },
              complete: function () {
                $t.find(".count-text").text(this.countNum);
              },
            }
          );
        }
      });
    }

    if ($("#datepicker").length) {
      $("#datepicker").datepicker();
    }

    if ($("#datepicker2").length) {
      $("#datepicker2").datepicker();
    }

    if ($("#datepicker-inline").length) {
      $("#datepicker-inline").datepicker();
    }

    $('input[name="time"]').ptTimeSelect();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.paymentMethod === "paystack") {
      setIsLoading(true);
      triggerPaystackPayment();
      return;
    }

    handleRegisterOnSheet("");
  };

  // Function to trigger Paystack payment
  const triggerPaystackPayment = () => {
    const handler = window.PaystackPop.setup({
      key: sheet_data["paystack_public_key"],
      email: formData.email || `${formData.phone}@conceptmultiservicesnig.com`,
      amount: formData.currency === "USD" ? formData.donationAmount : formData.donationAmount * 100, // Amount is in kobo (1 Naira = 100 Kobo)
      currency: formData.currency, //
      ref: "donation_" + Math.floor(Math.random() * 1000000), // Unique reference for each transaction
      metadata: {
        custom_fields: [
          {
            display_name: "First Name",
            variable_name: "first_name",
            value: formData.firstName,
          },
          {
            display_name: "Last Name",
            variable_name: "last_name",
            value: formData.lastName,
          },
        ],
      },
      callback: function (response) {
        handleRegisterOnSheet(response.reference);
      },
      onClose: function () {
        toast("Payment window closed")
        setIsLoading(false);
      },
    });

    handler.openIframe();
  };

  const handleRegisterOnSheet = async (
    reference = "donation_" + Math.floor(Math.random() * 1000000) + `_${Date.now()}`
  ) => {
    const scriptUrl = sheet_data["sheet_micro_url"];

    setIsLoading(true);
    await fetch(scriptUrl, {
      method: "POST",
      body: JSON.stringify({ ...formData, reference }),
      mode: "no-cors",
    })
      .then((res) => {
        if (res) {
          setFormData(FORM_DEFAULT);
        }
      })
      .catch((err) => {
        // setMessage("An error occurred. Please try again.");
      })
      .finally(function () {
        setIsLoading(true);
      });
  };

  return (
    <section className="donate-now">
      <div className="container" style={{ maxWidth: "750px" }}>
        <div>{sheet_data.isLoading && <Spinner />}</div>
        <div className="row" id="now">
          <div className="col-xl-12 col-lg-12">
            <div className="donate-now__left">
              <div className="donate-now__enter-donation">
                <h3 className="donate-now__title">Enter Your Donation</h3>
                <div className="donate-now__enter-donation-input">
                  <select
                    className="selectpicker"
                    name="currency"
                    onChange={handleInputChange}
                    value={formData.currency}
                  >
                    <option value={"NGN"}>₦</option>
                    <option value={"USD"}>$</option>
                  </select>
                  <input
                    type="text"
                    name="donationAmount"
                    placeholder="Enter amount"
                    value={formData.donationAmount}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="donate-now__personal-info-box">
                <h3 className="donate-now__title">Personal Info</h3>
                <form
                  className="donate-now__personal-info-form"
                  onSubmit={handleSubmit}
                >
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="donate-now__personal-info-input">
                        <Form.Group controlId="validationCustomUsername">
                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              placeholder="First Name"
                              aria-describedby="inputGroupPrepend"
                              required
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter first name.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="donate-now__personal-info-input">
                        <Form.Group controlId="validationCustomUsername">
                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              placeholder="Last Name"
                              aria-describedby="inputGroupPrepend"
                              required
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter last name.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="donate-now__personal-info-input">
                        <Form.Group controlId="validationCustomUsername">
                          <InputGroup hasValidation>
                            <Form.Control
                              type="email"
                              placeholder="Email Address"
                              aria-describedby="inputGroupPrepend"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please enter last name.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="donate-now__personal-info-input">
                        <Form.Group controlId="validationCustomUsername">
                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              placeholder="Phone Number"
                              aria-describedby="inputGroupPrepend"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please valid phone number.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="donate-now__personal-info-input">
                        <Form.Group controlId="validationCustomUsername">
                          <InputGroup hasValidation>
                            <Form.Control
                              type="text"
                              placeholder="Address"
                              aria-describedby="inputGroupPrepend"
                              name="address"
                              value={formData.address}
                              onChange={handleInputChange}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please valid address.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="donate-now__personal-info-input">
                        <Form.Select
                          name="country"
                          value={formData.country}
                          onChange={handleInputChange}
                        >
                          <option selected>Country</option>
                          {COUNTRIES.map((ctry, i) => (
                            <option
                              value={ctry.value}
                              // selected={ctry.value === "Nigeria"}
                              key={`${ctry.value}_${i}`}
                            >
                              {ctry.label}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="donate-now__personal-info-input donate-now__personal-info-message-box">
                        <textarea
                          name="message"
                          placeholder="Write a Comment"
                          value={formData.message}
                          onChange={handleInputChange}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="donate-now__payment-info mt-5">
                    <div style={{ marginBottom: "30px" }}>
                      <h3 className="donate-now__title" style={{ margin: 0 }}>
                        Payment Channels
                      </h3>
                      <p>
                        Please fill the form above and select your preffered
                        payment channel
                      </p>
                    </div>

                    <div className="row">
                      <div
                        className={`donate-now__payment-info-input col-lg-6  ${
                          sheet_data["paystack_public_key"] ? "" : "d-none"
                        }`}
                      >
                        <div
                          className={`card p-4  payment-channel ${
                            isActive("paystack")
                              ? "payment-channel-current"
                              : ""
                          } `}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handlePaymentMethodClick("paystack");
                          }}
                        >
                          <h6>Debit Card</h6>
                          <Row>
                            <Col sm={12}>
                              <img
                                src={
                                  publicUrl +
                                  "assets/images/resources/paystack-logos.png"
                                }
                                alt=""
                                width={"100%"}
                              />
                            </Col>
                            {/* <Col>
                              <span style={{ visibility: "hidden" }}>
                                checkout
                              </span>
                            </Col> */}
                          </Row>
                        </div>
                      </div>

                      <div className="donate-now__payment-info-input col-lg-6">
                        <div
                          className={`card p-4  payment-channel ${
                            isActive("cashapp") ? "payment-channel-current" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handlePaymentMethodClick("cashapp");
                          }}
                        >
                          <h6>CashApp</h6>
                          <Row>
                            <Col sm={12}>
                              <span style={{ fontSize: "12px" }}>
                                Account ID
                              </span>
                            </Col>
                            <Col>
                              <Copyable text={sheet_data.cashapp_id} />
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <div className="donate-now__payment-info-input col-lg-6">
                        <div
                          className={`card p-4  payment-channel ${
                            isActive("zelle") ? "payment-channel-current" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handlePaymentMethodClick("zelle");
                          }}
                        >
                          <h6>Zelle</h6>
                          <Row>
                            <Col sm={12}>
                              <span style={{ fontSize: "12px" }}>
                                Account ID
                              </span>
                            </Col>
                            <Col>
                              <Copyable text={sheet_data.zelle_id} />
                            </Col>
                          </Row>
                        </div>
                      </div>

                      <div className="donate-now__payment-info-input col-lg-6">
                        <div
                          className={`card p-4  payment-channel ${
                            isActive("banktransfer")
                              ? "payment-channel-current"
                              : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handlePaymentMethodClick("banktransfer");
                          }}
                        >
                          <h6>Bank Transfer</h6>
                          <Row>
                            <Col sm={12}>
                              <span style={{ fontSize: "12px" }}>
                                Account Number
                              </span>
                            </Col>
                            <Col>
                              <Copyable
                                text={removeSpaces(sheet_data.account_number)}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              <span style={{ fontSize: "12px" }}>
                                Account Name
                              </span>
                            </Col>
                            <Col>{sheet_data.account_name}</Col>
                          </Row>
                          <Row>
                            <Col sm={12}>
                              <span style={{ fontSize: "12px" }}>
                                Bank Name
                              </span>
                            </Col>

                            <Col>{sheet_data.bank_name}</Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="donate-now__payment-info-btn-box">
                    <button
                      type="submit"
                      className={`thm-btn donate-now__payment-info-btn ${
                        isLoading ||
                        !formData.paymentMethod ||
                        !formData.donationAmount.trim() ||
                        !formData.firstName.trim() ||
                        !formData.phone.trim()
                          ? "disabled"
                          : ""
                      } `}
                    >
                      {isLoading ? "Loading…" : "Continue"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DonateComponent;
